import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import SessionExpiredImg from "assets/images/session_time_out.png";
import { ErrorComponent, LoadingSpinner, MainFooter, PageLayout } from "shared";
import { sessionExpire } from "master/language";
import { useAppScope } from "master/contexts";

export const SessionExpired = () => {
  const navigate = useNavigate();
  const isFromMobileApp = sessionStorage.getItem("isFromMobileApp");
  const brandLogo = process.env.REACT_APP_MAIN_LOGO;
  const { lanSettings } = useAppScope();

  useEffect(() => {
    if (isFromMobileApp) {
      navigate("?tokenExpiredForMobileApp");
    }
  }, []);

  const goToLogin = () => {
    navigate("/login", { replace: true });
  };

  if (isFromMobileApp) {
    return <LoadingSpinner />;
  }

  return (
    <div id="app">
      <div id="main" className="layout-navbar">
        <div id="main-content">
          <header className="auth-header">
            <div className="container">
              <div className="row">
                <div className="header-block d-flex align-items-center justify-content-between">
                  <Link className="brand-logo" to="/login">
                    <img src={brandLogo} alt="nergy vidya" />
                  </Link>
                </div>
              </div>
            </div>
          </header>
          <PageLayout isPageEmpty={true} isBreadCrumbsRequired={false}>
            <div className="row">
              <div className="col-12 session_expired">
                <ErrorComponent
                  title={sessionExpire.title[lanSettings?.lan || "en"]}
                  message={sessionExpire.message[lanSettings?.lan || "en"]}
                  image={SessionExpiredImg}
                  btnLabel={sessionExpire.button[lanSettings?.lan || "en"]}
                  onClick={goToLogin}
                />
              </div>
            </div>
          </PageLayout>
          <MainFooter />
        </div>
      </div>
    </div>
  );
};
